import {
  Banknote,
  PiggyBank,
  Wallet,
  TrendingUp,
  ShieldCheck,
  Briefcase,
  ScrollText,
  CreditCard,
  HandCoins,
  Home,
  CircleDollarSign,
  Landmark,
  Coins,
  BadgePercent,
  Receipt,
  Building2,
} from 'lucide-react';

// Whitelisted icon names users can pick when creating a custom account type
export const ICON_OPTIONS = [
  { name: 'Banknote', Icon: Banknote },
  { name: 'PiggyBank', Icon: PiggyBank },
  { name: 'Wallet', Icon: Wallet },
  { name: 'TrendingUp', Icon: TrendingUp },
  { name: 'ShieldCheck', Icon: ShieldCheck },
  { name: 'Briefcase', Icon: Briefcase },
  { name: 'ScrollText', Icon: ScrollText },
  { name: 'CreditCard', Icon: CreditCard },
  { name: 'HandCoins', Icon: HandCoins },
  { name: 'Home', Icon: Home },
  { name: 'CircleDollarSign', Icon: CircleDollarSign },
  { name: 'Landmark', Icon: Landmark },
  { name: 'Coins', Icon: Coins },
  { name: 'BadgePercent', Icon: BadgePercent },
  { name: 'Receipt', Icon: Receipt },
  { name: 'Building2', Icon: Building2 },
];

const ICON_BY_NAME = Object.fromEntries(ICON_OPTIONS.map(({ name, Icon }) => [name, Icon]));

export const getAccountIcon = (iconName) => ICON_BY_NAME[iconName] || CircleDollarSign;
